import * as hasPreviouslyApplied from './hasPreviouslyApplied';
import * as educationBenefitsHistory from './educationBenefitsHistory';
import * as educationBenefitsEligibility from './educationBenefitsEligibility';
import * as payeeNumber from './payeeNumber';
import * as testName from './testName';
import * as organizationInfo from './organizationInfo';
import * as prepCourseName from './prepCourseName';
import * as prepCourseAddress from './prepCourseAddress';
import * as prepCourseOnline from './prepCourseOnline';
import * as prepCoursePeriod from './prepCoursePeriod';
import * as prepCourseCost from './prepCourseCost';
import * as remarks from './remarks';
import * as supportingDocuments from './supportingDocuments';

export {
  hasPreviouslyApplied,
  educationBenefitsHistory,
  educationBenefitsEligibility,
  payeeNumber,
  testName,
  organizationInfo,
  prepCourseName,
  prepCourseAddress,
  prepCourseOnline,
  prepCoursePeriod,
  prepCourseCost,
  remarks,
  supportingDocuments,
};
